import { Injectable } from '@angular/core';
import { SmartHttpService } from '@hrra/core';
import { UrlConfigService } from '@hrra/core';
import { UrlConfigContainer } from 'src/app/core/url-config';
import { BasicOptionItem } from '@hrra/common-models';
import { JobseekerValidationCodeRequest } from 'src/app/root-store/jobseeker-store/jobseeker-settings/state';

@Injectable({
  providedIn: 'root'
})
export class JobseekerSettingsService {

  public getJobseekerPrivacy(){
    return this.smartHttp.get<JobseekerPrivacyViewModel>(this.urlService.urlConfig.api.data.jobseekers.privacy, {});
  }

  public requestVerificationCode(email: string, password: string){
    const data = {
      email: email,
      currentPassword: password
    };
    return this.smartHttp.post<JobseekerValidationCodeRequest>(this.urlService.urlConfig.api.data.jobseekers.requestVerificationCode, data)
  }

  public confirmUserEmail(data: JobseekerEmailUpdateData){
    const confirmData = {
      requestId: data.requestId,
      currentPassword: data.currentPassword,
      validationCode: data.validationCode,
      newEmail: data.newEmail
    };
    return this.smartHttp.post<JobseekerEmailUpdateData>(this.urlService.urlConfig.api.data.jobseekers.confirmJobseekerEmailUpdate, confirmData);
  }

  public updateEmail(email: string, password: string){
    const data = {
      newEmail: email,
      currentPassword: password
    };
    return this.smartHttp.post<JobseekerChangeEmailViewModel>(this.urlService.urlConfig.api.data.jobseekers.initialEmailChange, data);
  }

  public updateJobseekerPrivacy(privacyId: number){
    let data: JobseekerPrivacyViewModel = {
      privacyId: privacyId
    }
    return this.smartHttp.post<JobseekerPrivacyViewModel>(this.urlService.urlConfig.api.data.jobseekers.privacy, data);
  }

  public changeJobseekerPassword(pass: JobseekerChangePasswordViewModel) {
    return this.smartHttp.post<JobseekerPrivacyViewModel>(this.urlService.urlConfig.api.data.jobseekers.changePassword, pass);
  }

  public getJobseekerBlacklist(name: string){
    return this.smartHttp.get<JobseekerBlackListViewModel>(this.urlService.urlConfig.api.data.jobseekers.blacklist, { name });
  }

  public updateJobseekerBlacklist(data: JobseekerBlacklistUpdateViewModel){
    return this.smartHttp.post<JobseekerBlackListViewModel>(this.urlService.urlConfig.api.data.jobseekers.blacklist, data);
  }

  constructor(private smartHttp: SmartHttpService, private urlService: UrlConfigService<UrlConfigContainer>) { }
}


export interface JobseekerPrivacyViewModel{
  privacyId: number;
}

export interface JobseekerEmailUpdateData{
  requestId: string;
  currentPassword: string;
  validationCode: number;
  newEmail: string;
}

export interface JobseekerChangeEmailViewModel{
  currentPassword: string;
  newEmail: string;
}

export interface JobseekerChangePasswordViewModel {
  currentPassword: String;
  newPassword: String;
  repeatNewPassword: String;
}

export interface JobseekerBlackListViewModel{
  jobseekerIgnoredCustomerList: BasicOptionItem[];
  customerList: BasicOptionItem[];
}

export interface JobseekerBlacklistUpdateViewModel{
  ignoredCustomerList: number[];
}